import React from 'react';
import { Box, Section, Image } from '@common/components';
import { Button, Row, Col, Typography } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';

const Guest = ({ guest, onClick, onEdit, onDelete }) => {
	return (
		<Box className="p-5" onClick={() => onClick && onClick(guest)}>
			<Section className="mb-3" hoverable shadowed>
				<Image src={guest?.thumbnail?.path} width="100%" mb={20} />
				<Row type="flex" className="login-links">
					<Col>
						<Typography.Title level={4}>
							{guest.title}
						</Typography.Title>
					</Col>
				</Row>
				<Box textAlign="right">
					{onEdit && (
						<Button
							size="small"
							type="text"
							onClick={() => onEdit && onEdit(guest)}>
							<EditFilled style={{ color: '#FFCC00' }} />
						</Button>
					)}
					{onDelete && (
						<Button
							size="small"
							type="text"
							onClick={() => onDelete && onDelete(guest)}>
							<DeleteFilled style={{ color: '#FF0000' }} />
						</Button>
					)}
				</Box>
			</Section>
		</Box>
	);
};

export default Guest;
